// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"234":"0060f3ef","267":"1dba3816","519":"e08f3e6e","538":"a27ecd3b","618":"e79b637c","810":"0060f3ef","827":"36f4e878","878":"8f12ba1b","934":"1dba3816","949":"35036201","972":"0060f3ef"}[chunkId] + ".chunk.css";
};